var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DistributorList"},[_c('div',{staticClass:"row"},_vm._l((_vm.distributors),function(item){return _c('div',{key:item.id,staticClass:"col-12 col-sm-6 col-md-6 col-lg-4"},[_c('DistributorCard',{attrs:{"distributor":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }